import gravatarUrl from 'gravatar-url'

export function generateAvatarUrl(emailAddress, options = { size: 200 }) {
  // const defaultImage = options.defaultImage || "identicon"
  // const emailHash = md5(emailAddress)

  return gravatarUrl(emailAddress, options)

}